// TODO: Write tests for this file

import React from "react";
import { useLocation, useHistory } from "react-router-dom";
import { GKSelect } from "@granular/gds-ux-components";

import { DynamicDocs, useGetDocsPageRoute } from "./helpers";

export type FederatedModulesDocsAppSelectProps = {
  dynamicDocs: DynamicDocs[];
};

type DataItem = {
  name: string;
  value: string;
  description?: string;
};

const itemTemplate = (item: DataItem): JSX.Element => (
  <div>
    <div>{item.name}</div>
    {item.description && (
      <div>
        <small>{item.description}</small>
      </div>
    )}
  </div>
);

const itemToString = (item: DataItem): string => item.name;

export const FederatedModulesDocsAppSelect: React.FC<
  FederatedModulesDocsAppSelectProps
> = ({ dynamicDocs }) => {
  const location = useLocation();
  const history = useHistory();
  const getDocsPageRoute = useGetDocsPageRoute();

  const { pathname } = location;

  const data: DataItem[] = React.useMemo(
    () =>
      dynamicDocs.map(({ name, docgenResult, route }) => {
        let description = docgenResult.description;
        if (description) {
          const indexOfFirstLineBreak = description.indexOf("\n");
          if (indexOfFirstLineBreak !== -1) {
            description = description.slice(0, indexOfFirstLineBreak + 1);
          }
        }
        return {
          name,
          value: getDocsPageRoute({ docsPage: route }),
          description,
        };
      }),
    [dynamicDocs, getDocsPageRoute],
  );

  const selectedItem = React.useMemo(
    () => data.find((x) => x.value === pathname),
    [data, pathname],
  );

  const handleChange = React.useCallback(
    (item: DataItem | undefined): void => {
      if (item) {
        history.push(item.value);
      }
    },
    [history],
  );

  return (
    <GKSelect
      data={data}
      itemTemplate={itemTemplate}
      itemToString={itemToString}
      selectedItem={selectedItem}
      onChange={handleChange}
      placeholder="Select an item"
    />
  );
};
